import SearchCombinationButton from './SearchCombinationButton'

export default SearchCombinationButton